import React, { Component } from "react"
import classNames from "classnames"
import { find } from "lodash/collection"
import { pick } from "lodash/object"
import Icon from "../elements/Icon"
import markdown from "../../scripts/markdown"
import PinterestShare from "../elements/PinterestShare"
import { trackSocial } from "../../analyticsAndSocial"
import Relay from "react-relay"
import BookDownload from "../elements/BookDownload"
import VideoDownload from "../elements/VideoDownload"
import AudioDownload from "../elements/AudioDownload"
import ImageDownload from "../elements/ImageDownload"
import {
  getPermalink,
  getImageType,
  getImageSrcFromFile
} from "../../scripts/resource"
import { licenseTypes, licenseDefinitions } from "../../scripts/licenseTypes"
import Licence from "../elements/Licence"
import ResourceAttribution from "../elements/ResourceAttribution"
import { FormattedMessage, injectIntl } from "react-intl"
import shareMessages from "../../messages/share"
import { messages as licenseMessages } from "../../messages/licenses"
import settingsMessages from "../../messages/settings"
import Image from "../elements/Image"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import { filterHTML } from "../../scripts/xss"

class ShareModal extends Component {
  setActiveTab = activeTab => () => {
    this.props.relay.setVariables({ activeTab })
  }

  render() {
    const {
      intl,
      onClose,
      resource,
      relay: {
        variables: { activeTab }
      },
      showDownloads,
      isCopyright
    } = this.props
    const { license: licenseProp } = JSON.parse(resource.custom_fields)

    const permalink = getPermalink(resource)
    const encodedPermalink = encodeURIComponent(permalink)
    const license = find(licenseTypes, {
      name: licenseProp ? licenseProp.value : "some_restrictions_apply"
    })

    const {
      settings: { contact_email: contactEmail, twitter_handle: twitterHandle }
    } = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )

    const description =
      license && license.description && license.description in licenseMessages
        ? intl.formatMessage(licenseMessages[license.description], {
            email: contactEmail
          })
        : ""

    const licenseDetail =
      license && license.definitions
        ? Object.values(pick(licenseDefinitions, license.definitions))
        : []

    const titleEscaped = encodeURIComponent(resource.title)

    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodedPermalink}&t=${titleEscaped}`
    const twitterLink = `https://twitter.com/share?url=${encodedPermalink}${
      twitterHandle ? "&via=" + twitterHandle : ""
    }&text=${titleEscaped}`

    return (
      <span>
        <div
          className="c-share-modal modal-inner"
          style={getStyles(["c-share-modal", "modal-inner"])}
        >
          {getStyleTag("list__def--simple")}
          <h3 className="beta">
            <FormattedMessage {...shareMessages.shareOrUse} />
          </h3>
          <p>
            <FormattedMessage {...shareMessages.beforeSharing} />
          </p>
          <h4 className="beta">
            <Licence resource={resource} />
          </h4>
          {description && (
            <div
              dangerouslySetInnerHTML={{
                __html: markdown.render(filterHTML(description))
              }}
            />
          )}
          {licenseDetail.length > 0 && (
            <div className="rights">
              <dl className="list__def list__def--simple">
                {licenseDetail.map((definition, i) => {
                  const { titleId, descriptionId } = definition

                  const title =
                    titleId in licenseMessages
                      ? intl.formatMessage(licenseMessages[titleId])
                      : ""

                  const detail =
                    descriptionId in licenseMessages
                      ? intl.formatMessage(licenseMessages[descriptionId])
                      : ""

                  return (
                    <div key={i} style={getStyles("list__def--simple__div")}>
                      {title && <dt>{title}</dt>}
                      {detail && (
                        <dd
                          dangerouslySetInnerHTML={{
                            __html: markdown.render(filterHTML(detail))
                          }}
                        />
                      )}
                    </div>
                  )
                })}
              </dl>
            </div>
          )}
          <div
            className={classNames("c-tabs c-tabs--default c-tabs--centered")}
            style={getStyles("list__def--simple__tabs")}
          >
            {getStyleTag("c-tabs--default__tab")}
            <nav className="c-tabs__nav">
              <button
                onClick={this.setActiveTab("share")}
                className={classNames("c-tabs__tab", {
                  "state-active": activeTab === "share" || !showDownloads
                })}
                // activeClassName="state-active"
              >
                <FormattedMessage {...shareMessages.share} />
              </button>
              {showDownloads && (
                <button
                  onClick={this.setActiveTab("download")}
                  className={classNames("c-tabs__tab", {
                    "state-active": activeTab === "download"
                  })}
                  // activeClassName="state-active"
                >
                  <FormattedMessage {...shareMessages.download} />
                </button>
              )}
            </nav>
            <div className="c-tabs__content c-tabs__content--flush-edges c-tabs__content--flush-bottom state-active">
              {showDownloads &&
              activeTab === "download" &&
              resource.files.length > 0
                ? resource.files.map(file => {
                    if (
                      file.type === "cover_image" ||
                      file.type === "captions" ||
                      file.type === "transcription"
                    ) {
                      return null
                    }

                    const { type: fileType } = file
                    const imageSrc = getImageSrcFromFile(
                      file,
                      "small",
                      getImageType(fileType),
                      true
                    )

                    return (
                      <div className="media-object" key={file.__dataID__}>
                        <div className="media-object-section c-share-modal__image-section">
                          <div className="thumbnail c-share-modal__image-preview">
                            <Image src={imageSrc} />
                          </div>
                        </div>
                        <div className="media-object-section">
                          <ResourceAttribution
                            className="mbs"
                            resource={resource}
                            file={file}
                            title={"default"}
                          />
                          {fileType === "image" && (
                            <ImageDownload
                              isCopyright={isCopyright}
                              resource={resource}
                              file={file}
                            />
                          )}
                          {fileType === "audio" && (
                            <AudioDownload
                              resource={resource}
                              audioFile={file}
                            />
                          )}
                          {fileType === "video" && (
                            <VideoDownload
                              resource={resource}
                              videoFile={file}
                            />
                          )}
                          {fileType === "book" && (
                            <BookDownload resource={resource} bookFile={file} />
                          )}
                        </div>
                      </div>
                    )
                  })
                : null}
              <div />

              {activeTab === "share" && (
                <div>
                  <ul className="c-share-modal__share-icons list--inline">
                    <li>
                      <a
                        role="menuitem"
                        onClick={e => {
                          e.preventDefault()
                          window.open(
                            facebookLink,
                            "",
                            "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
                          )
                          trackSocial("Facebook", permalink)
                          return false
                        }}
                        target="_blank"
                        className="c-article__share-link"
                      >
                        <Icon
                          title={intl.formatMessage(
                            shareMessages.shareFacebook
                          )}
                          icon="facebook-circle"
                          extraClasses="icon--color-facebook"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        role="menuitem"
                        href={twitterLink}
                        onClick={e => {
                          e.preventDefault()
                          window.open(
                            twitterLink,
                            "",
                            "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
                          )
                          trackSocial("Twitter", permalink)
                          return false
                        }}
                        target="_blank"
                        className="c-article__share-link"
                      >
                        <Icon
                          title={intl.formatMessage(shareMessages.shareTwitter)}
                          icon="twitter-circle"
                          extraClasses="icon--color-twitter"
                        />
                      </a>
                    </li>
                    <li>
                      <PinterestShare
                        role="menuitem"
                        className="c-article__share-link"
                        resource={resource}
                        pinterestColor
                      />
                    </li>
                    <li>
                      <a
                        role="menuitem"
                        href={
                          "mailto:?subject=" +
                          titleEscaped +
                          "&body=" +
                          titleEscaped +
                          " - " +
                          permalink
                        }
                        className="c-article__share-link"
                      >
                        <Icon
                          title={intl.formatMessage(shareMessages.shareEmail)}
                          icon="email-circle"
                        />
                      </a>
                    </li>
                  </ul>
                  <ResourceAttribution resource={resource} title="default" />
                  <p
                    className="mtt panel panel--white panel--tight"
                    itemProp="url"
                  >
                    <a href={permalink}>{permalink}</a>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        {getStyleTag("modal-close")}
        <button
          className="modal-close"
          style={getStyles("modal-close")}
          onClick={onClose}
        >
          <Icon title="Close modal" icon="cross" />
        </button>
      </span>
    )
  }
}

export default Relay.createContainer(injectIntl(ShareModal), {
  initialVariables: {
    activeTab: "share"
  },

  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        type
        title
        custom_fields
        files {
          type
          size
          images {
            small { url width height mime_type }
            large { url width height mime_type}
            original { url width height mime_type }
          }
          audio {
            lossy {
              url
              mime_type
            }
          }
          video {
            med {
              url
              mime_type
            }
            low {
              url
              mime_type
            }
          }
          documents {
            pdf {
              mime_type
              url
            }
          }
        }
        ${PinterestShare.getFragment("resource")}
        ${BookDownload.getFragment("resource")}
        ${VideoDownload.getFragment("resource")}
        ${AudioDownload.getFragment("resource")}
        ${ImageDownload.getFragment("resource")}
        ${ResourceAttribution.getFragment("resource")}
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/ShareModal.js